// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27%23475569%27 viewBox=%270 0 256 256%27%3E%3Cpath d=%27M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.curator-groups-section {
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  height: auto;
  min-height: auto
}

/* Заголовок */
.curator-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.curator-header-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.header-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  height: 48px;
}

.header-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.header-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Информационная иконка */
.info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.info-icon-text {
  font-weight: 700;
  font-size: 16px;
  color: #002FA7;
}

.info-icon-btn:hover .info-tooltip,
.info-icon-btn:focus-within .info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
}

.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(10px);
  background: white;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 20px;
  width: 320px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.info-tooltip-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}

/* Кнопка обновления */
.pc-refresh-icon {
  width: 22px;
  height: 22px;
  transition: transform 0.3s ease;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Предупреждения и ошибки */
.curator-cache-warning,
.curator-error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  animation: slideIn 0.3s ease;
}

.curator-cache-warning {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #fcd34d;
  color: #92400e;
}

.curator-error-message {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #fca5a5;
  color: #991b1b;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Панель управления */
.curator-control-panel-enhanced {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Поиск и переключатель вида */
.curator-controls-top-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: center;
}

.curator-search-box-enhanced {
  position: relative;
  flex: 1 1;
}

.curator-search-input-enhanced {
  width: 100%;
  padding: 14px 20px 14px 48px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
  font-weight: 500;
}

.curator-search-input-enhanced:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.curator-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.curator-search-icon img {
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

.curator-view-toggle {
  display: flex;
  background: #f8fafc;
  border-radius: 12px;
  padding: 4px;
  border: 2px solid #e2e8f0;
  gap: 4px;
  flex-shrink: 0;
}

.curator-view-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.curator-view-btn:hover {
  background: #e2e8f0;
}

.curator-view-btn.curator-view-active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.curator-view-btn img {
  width: 18px;
  height: 18px;
  opacity: 0.7;
}

.curator-view-btn.curator-view-active img {
  opacity: 1;
}

/* Нижняя строка с сортировкой и фильтром */
.curator-controls-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 2px solid #f1f5f9;
}

.curator-sort-controls-enhanced {
  flex: 1 1;
  min-width: 400px;
}

.curator-sort-group {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.curator-sort-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.curator-sort-select {
  min-width: 200px;
  max-width: 300px;
}

.curator-sort-order-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.curator-sort-order-btn:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.curator-sort-order-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
}

/* Фильтр по курсу справа */
.curator-course-filter-right {
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
}

.curator-course-filter-right .curator-filter-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  margin: 0;
}

.curator-course-select {
  min-width: 140px;
  width: auto;
}

/* Общие стили для селектов */
.curator-filter-select-enhanced {
  padding: 10px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-size: 14px;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding-right: 44px;
}

.curator-filter-select-enhanced:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

/* Контент с группами - восстановлен оригинальный дизайн */
.curator-content-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.curator-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.curator-section-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
}

.curator-groups-count {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64748b;
  background: #f8fafc;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.curator-groups-count img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  opacity: 0.7;
}

.curator-groups-count span {
  color: #002FA7;
  font-weight: 600;
}

/* Состояния загрузки и ошибок */
.curator-loading {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.curator-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 47, 167, 0.1);
  border-left: 3px solid #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Карточки групп */
.curator-groups-cards-container {
  max-width: 100%;
}

.curator-groups-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.curator-group-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  overflow: hidden;
}

.curator-group-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);
  border-color: #002FA7;
}

.curator-group-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);
}

.curator-empty-state {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.curator-empty-subtitle {
  margin-top: 8px;
  color: #94a3b8;
  font-size: 14px;
}

/* Верхняя часть карточки */
.curator-card-top {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.curator-card-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.curator-card-group-number {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.curator-group-number-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.curator-group-number-value {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
}

.curator-card-course {
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.curator-course-label {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
}

.curator-card-specialty h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Компактное отображение количества студентов */
.curator-card-students-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  width: fit-content;
}

.curator-students-icon img{
  width: 16px;
  height: 16px;
  align-items: center;
  margin-top: 2px;  
}

.curator-students-count {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

/* Показатели */
.curator-card-metrics {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.curator-card-metric {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.curator-metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.curator-metric-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.curator-metric-value {
  font-size: 16px;
  font-weight: 700;
  color: #002FA7;
}

.curator-metric-progress {
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
}

.curator-metric-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

/* Староста */
.curator-card-headman {
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}

.curator-headman-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.curator-headman-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.curator-headman-value {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Список групп */
.curator-groups-list-container {
  max-width: 100%;
}

.curator-groups-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.curator-group-list-item {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.curator-group-list-item:hover {
  background: #f8fafc;
  border-color: #002FA7;
  transform: translateX(4px);
}

.curator-group-list-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #002FA7;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.curator-group-list-item:hover::before {
  opacity: 1;
}

.curator-list-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.curator-list-header {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.curator-list-group-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.curator-list-group-number {
  font-size: 18px;
  font-weight: 700;
  color: #002FA7;
}

.curator-list-course-badge {
  background: #002FA7;
  color: white;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.curator-list-specialty {
  font-size: 15px;
  color: #1e293b;
  font-weight: 500;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.curator-list-details {
  display: flex;
  gap: 20px;
  align-items: center;
}

.curator-list-detail {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.curator-list-detail.compact {
  background: #f8fafc;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.curator-detail-label {
  color: #64748b;
  font-weight: 500;
}

.curator-detail-value {
  color: #002FA7;
  font-weight: 600;
}

.curator-list-metrics {
  display: flex;
  gap: 24px;
  min-width: 320px;
}

.curator-list-metric {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.curator-list-metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.curator-list-metric-header span:first-child {
  color: #64748b;
  font-weight: 500;
}

.curator-list-metric-header span:last-child {
  color: #002FA7;
  font-weight: 700;
  font-size: 14px;
}

.curator-list-progress {
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
}

.curator-list-progress-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}


/* Детальная информация о группе */
.curator-details-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.curator-details-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.curator-back-btn {
  background: white;
  border: none;
  padding: 0;
  border-radius: 50%;
  margin-left: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.curator-back-btn:hover {
  background: white;
  transform: scale(1.1);  
}

.curator-back-btn img {
  width: 30px;
  height: 30px;
  transition: all 0.2s ease;
}

.curator-details-header h2 {
  margin: 0;
  color: #002FA7;
  font-size: 24px;
  font-weight: 700;
}

.curator-monitor-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  background: white;
}

.curator-monitor-radio:checked {
  border-color: #002FA7;
  background: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.curator-monitor-radio:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}

.curator-monitor-radio:hover {
  border-color: #002FA7;
  transform: scale(1.1);
}

.curator-monitor-radio:focus {
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.2);
}

/* Стили для ячейки с радио-кнопкой */
.curator-student-actions {
  width: 60px;
  text-align: center;
  vertical-align: middle;
}

.curator-student-actions input[type="radio"] {
  margin: 0 auto;
  display: block;
}


/* Секция старосты */
.curator-monitor-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
}

.curator-monitor-section h3 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.curator-monitor-section h3 img {
  width: 24px;
  height: 24px;
}

/* Красивая карточка старосты - минималистичный дизайн */
.curator-monitor-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e6edf5;
  flex-wrap: wrap;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.06);
  transition: all 0.2s ease;
}

.curator-monitor-card:hover {
  border-color: #cbd6e6;
  box-shadow: 0 6px 16px rgba(0, 47, 167, 0.1);
}

.curator-monitor-details {
  flex: 1 1;
  min-width: 250px;
}

.curator-monitor-name-large {
  font-size: 18px;
  font-weight: 600;
  color: #002FA7;
  margin-bottom: 10px;
  letter-spacing: -0.2px;
}

.curator-monitor-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  font-size: 14px;
  color: #4f5b66;
  flex-wrap: wrap;
  width: 100%;
}

/* Левая группа - дата */
.curator-monitor-meta .meta-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

/* Правая группа - телефон и почта */
.curator-monitor-meta .meta-right {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-left: auto;
}

.curator-monitor-meta .meta-right span {
  color: #3a4b63;
  font-weight: 500;
  white-space: nowrap;
}

/* Адаптивность */
@media (max-width: 768px) {
  .curator-monitor-card {
    padding: 16px 20px;
  }
  
  .curator-monitor-name-large {
    font-size: 18px;
  }
  
  .curator-monitor-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .curator-monitor-meta .meta-right {
    margin-left: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
  
  .curator-monitor-meta .meta-right span {
    white-space: normal;
  }
}

/* Таблица студентов */
.curator-students-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
}

.curator-students-section h3 {
  margin: 0 0 20px 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.curator-students-section h3 img {
  width: 24px;
  height: 24px;
}

.curator-students-table-container {
  width: 100%;
  overflow-x: auto;
}

.curator-students-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
}

.curator-students-table th {
  background: #f8fafc;
  color: #002c9c;
  font-size: 13px;
  font-weight: 600;
  padding: 12px 8px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
}

.curator-students-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 13px;
}

.curator-student-number {
  width: 40px;
  text-align: center;
  color: #64748b;
}

.curator-student-name {
  min-width: 200px;
}

.curator-student-attendance {
  width: 70px;
  text-align: center;
}

.curator-attendance-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 20px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  min-width: 45px;
  text-align: center;
}

.curator-student-average {
  width: 70px;
  text-align: center;
  font-weight: 600;
}

.curator-student-actions {
  width: 60px;
  text-align: center;
}

.curator-action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.curator-action-btn:hover {
  background: #f1f5f9;
}

.curator-action-btn img {
  width: 16px;
  height: 16px;
}

/* Социальный портрет */
.curator-social-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
}

.curator-social-header {
  margin-bottom: 20px;
}

.curator-social-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.curator-social-header h3 img {
  width: 24px;
  height: 24px;
}

.curator-social-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.curator-social-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.curator-social-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.curator-social-card-header h4 {
  margin: 0;
  color: #002FA7;
  font-size: 15px;
  font-weight: 700;
}

.curator-social-count {
  background: #e2e8f0;
  color: #002FA7;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.curator-social-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.curator-social-list li {
  padding: 6px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.curator-social-list li:last-child {
  border-bottom: none;
}

.curator-social-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px dashed #e2e8f0;
}

/* Модальные окна */
.curator-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.curator-modal {
  background: white;
  border-radius: 16px;
  padding: 0;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: curator-modal-appear 0.2s ease-out;
}

@keyframes curator-modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.curator-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 16px 16px 0 0;
  color: white;
}

.curator-modal-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.curator-modal-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.curator-modal-icon img {
  width: 22px;
  height: 22px;
  filter: brightness(0) invert(1);
}

.curator-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.curator-modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  opacity: 0.9;
  font-weight: 400;
  color: white;
}

.curator-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.curator-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.curator-modal-content {
  padding: 24px;
}

.curator-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 16px 16px;
  flex-wrap: wrap;
}

/* Формы */
.curator-form-group {
  margin-bottom: 20px;
}

.curator-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

.curator-input,
.curator-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

.curator-input:focus,
.curator-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.curator-form-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

/* Кнопки в модальных окнах */
.curator-btn-secondary {
  padding: 10px 20px;
  background: white;
  color: #1e293b;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-btn-secondary:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.curator-confirm-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

/* Список студентов для смены старосты */
.curator-students-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
}

.curator-student-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.curator-student-option:hover {
  border-color: #002FA7;
  background: white;
  transform: translateX(4px);
}

.curator-student-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}

.curator-student-info {
  flex: 1 1;
  min-width: 0;
}

.curator-student-name-option {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.curator-student-details {
  font-size: 12px;
  color: #64748b;
}

/* Адаптивность */
@media (max-width: 1200px) {
  .curator-groups-cards {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 1024px) {
  .curator-controls-top-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .curator-view-toggle {
    width: 100%;
    justify-content: center;
  }
  
  .curator-view-btn {
    flex: 1 1;
    justify-content: center;
  }
  
  .curator-controls-bottom-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .curator-sort-controls-enhanced {
    min-width: 100%;
  }
  
  .curator-sort-group {
    width: 100%;
  }
  
  .curator-sort-select {
    flex: 1 1;
  }
  
  .curator-course-filter-right {
    width: 100%;
    justify-content: flex-start;
  }
  
  .curator-list-metrics {
    min-width: 250px;
  }
}

@media (max-width: 768px) {
  .curator-cabinet-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .curator-header-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .curator-control-panel-enhanced {
    padding: 16px;
  }
  
  .curator-section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .curator-groups-count {
    align-self: flex-start;
  }
  
  .curator-group-card {
    padding: 16px;
  }
  
  .curator-card-stats {
    flex-wrap: wrap;
  }
  
  .curator-group-list-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .curator-list-number {
    display: none;
  }
  
  .curator-list-info {
    width: 100%;
  }
  
  .curator-list-header {
    justify-content: space-between;
    width: 100%;
  }
  
  .curator-list-stats {
    justify-content: space-between;
  }
  
  .curator-view-toggle {
    width: 100%;
    justify-content: center;
  }
  
  .curator-sort-group {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 12px;
  }
  
  .curator-sort-select {
    width: 100%;
    max-width: none;
  }
  
  .curator-sort-order-btn {
    width: 100%;
    justify-content: center;
  }
  
  .curator-sort-buttons {
    width: 100%;
  }
  
  .curator-course-filter-right {
    flex-wrap: wrap;
  }
  
  .curator-course-select {
    flex: 1 1;
  }
  
  .curator-details-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .curator-monitor-card {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .curator-monitor-meta {
    flex-direction: column;
    gap: 8px;
  }
  
  .curator-monitor-change-btn {
    width: 100%;
    justify-content: center;
  }
  
  .curator-social-grid {
    grid-template-columns: 1fr;
  }
  
  .curator-modal-actions {
    flex-direction: column;
  }
  
  .curator-btn-secondary,
  .curator-confirm-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .curator-groups-cards {
    grid-template-columns: 1fr;
  }
  
  .curator-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .curator-card-course {
    align-self: flex-start;
  }
  
  .curator-view-btn span {
    display: none;
  }
  
  .curator-view-btn {
    padding: 10px;
  }
  
  .curator-sort-order-btn span {
    display: none;
  }
  
  .curator-sort-order-btn {
    padding: 10px;
    justify-content: center;
  }
  
  .curator-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .curator-list-stats {
    flex-direction: column;
    gap: 8px;
  }
  
  .curator-card-stats {
    flex-direction: column;
  }
}

/* Обновленные стили для кнопки назад */
.curator-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.curator-back-btn:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.curator-back-btn:active {
  transform: translateY(0);
}

.curator-back-btn img {
  width: 18px;
  height: 18px;
}

/* Мультистрочное отображение старост */
.curator-headman-value {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.curator-monitor-name-line {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  line-height: 1.3;
}

.curator-detail-value-multiline {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.curator-detail-value-multiline div {
  font-size: 13px;
  color: #002FA7;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/th-components/CuratorSection.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,yDAA4S;EAC5S,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;;AAGA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;;AAGA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".curator-groups-section {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  height: auto;\n  min-height: auto\n}\n\n/* Заголовок */\n.curator-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.curator-header-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.header-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  height: 48px;\n}\n\n.header-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.header-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Информационная иконка */\n.info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.info-icon-text {\n  font-weight: 700;\n  font-size: 16px;\n  color: #002FA7;\n}\n\n.info-icon-btn:hover .info-tooltip,\n.info-icon-btn:focus-within .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(10px);\n  background: white;\n  border: 2px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 320px;\n  max-width: calc(100vw - 40px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.info-tooltip-content {\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* Кнопка обновления */\n.pc-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s ease;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Предупреждения и ошибки */\n.curator-cache-warning,\n.curator-error-message {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  animation: slideIn 0.3s ease;\n}\n\n.curator-cache-warning {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 2px solid #fcd34d;\n  color: #92400e;\n}\n\n.curator-error-message {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  border: 2px solid #fca5a5;\n  color: #991b1b;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Панель управления */\n.curator-control-panel-enhanced {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Поиск и переключатель вида */\n.curator-controls-top-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 24px;\n  align-items: center;\n}\n\n.curator-search-box-enhanced {\n  position: relative;\n  flex: 1;\n}\n\n.curator-search-input-enhanced {\n  width: 100%;\n  padding: 14px 20px 14px 48px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n  font-weight: 500;\n}\n\n.curator-search-input-enhanced:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.curator-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  pointer-events: none;\n}\n\n.curator-search-icon img {\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n}\n\n.curator-view-toggle {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 4px;\n  border: 2px solid #e2e8f0;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.curator-view-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.curator-view-btn:hover {\n  background: #e2e8f0;\n}\n\n.curator-view-btn.curator-view-active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.curator-view-btn img {\n  width: 18px;\n  height: 18px;\n  opacity: 0.7;\n}\n\n.curator-view-btn.curator-view-active img {\n  opacity: 1;\n}\n\n/* Нижняя строка с сортировкой и фильтром */\n.curator-controls-bottom-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  padding-top: 20px;\n  border-top: 2px solid #f1f5f9;\n}\n\n.curator-sort-controls-enhanced {\n  flex: 1;\n  min-width: 400px;\n}\n\n.curator-sort-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.curator-sort-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.curator-sort-select {\n  min-width: 200px;\n  max-width: 300px;\n}\n\n.curator-sort-order-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.curator-sort-order-btn:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.curator-sort-order-icon {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n}\n\n/* Фильтр по курсу справа */\n.curator-course-filter-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  white-space: nowrap;\n}\n\n.curator-course-filter-right .curator-filter-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  margin: 0;\n}\n\n.curator-course-select {\n  min-width: 140px;\n  width: auto;\n}\n\n/* Общие стили для селектов */\n.curator-filter-select-enhanced {\n  padding: 10px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  background: white;\n  font-size: 14px;\n  color: #1e293b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23475569' viewBox='0 0 256 256'%3E%3Cpath d='M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 16px;\n  padding-right: 44px;\n}\n\n.curator-filter-select-enhanced:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n/* Контент с группами - восстановлен оригинальный дизайн */\n.curator-content-section {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.curator-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.curator-section-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.curator-groups-count {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #64748b;\n  background: #f8fafc;\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-groups-count img {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  opacity: 0.7;\n}\n\n.curator-groups-count span {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n/* Состояния загрузки и ошибок */\n.curator-loading {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.curator-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 47, 167, 0.1);\n  border-left: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Карточки групп */\n.curator-groups-cards-container {\n  max-width: 100%;\n}\n\n.curator-groups-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.curator-group-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.curator-group-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.15);\n  border-color: #002FA7;\n}\n\n.curator-group-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #002FA7 0%, #5986f7 100%);\n}\n\n.curator-empty-state {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.curator-empty-subtitle {\n  margin-top: 8px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n/* Верхняя часть карточки */\n.curator-card-top {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.curator-card-group-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.curator-card-group-number {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.curator-group-number-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.curator-group-number-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.curator-card-course {\n  background: #f1f5f9;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-course-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.curator-card-specialty h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Компактное отображение количества студентов */\n.curator-card-students-compact {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #f8fafc;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  width: fit-content;\n}\n\n.curator-students-icon img{\n  width: 16px;\n  height: 16px;\n  align-items: center;\n  margin-top: 2px;  \n}\n\n.curator-students-count {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n/* Показатели */\n.curator-card-metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.curator-card-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.curator-metric-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.curator-metric-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.curator-metric-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.curator-metric-progress {\n  height: 6px;\n  background: #f1f5f9;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.curator-metric-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n/* Староста */\n.curator-card-headman {\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.curator-headman-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.curator-headman-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.curator-headman-value {\n  font-size: 14px;\n  color: #1e293b;\n  font-weight: 500;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Список групп */\n.curator-groups-list-container {\n  max-width: 100%;\n}\n\n.curator-groups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.curator-group-list-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  background: white;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.curator-group-list-item:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  transform: translateX(4px);\n}\n\n.curator-group-list-item::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: #002FA7;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.curator-group-list-item:hover::before {\n  opacity: 1;\n}\n\n.curator-list-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.curator-list-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.curator-list-group-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.curator-list-group-number {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.curator-list-course-badge {\n  background: #002FA7;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.curator-list-specialty {\n  font-size: 15px;\n  color: #1e293b;\n  font-weight: 500;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.curator-list-details {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.curator-list-detail {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.curator-list-detail.compact {\n  background: #f8fafc;\n  padding: 4px 10px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-detail-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.curator-detail-value {\n  color: #002FA7;\n  font-weight: 600;\n}\n\n.curator-list-metrics {\n  display: flex;\n  gap: 24px;\n  min-width: 320px;\n}\n\n.curator-list-metric {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.curator-list-metric-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.curator-list-metric-header span:first-child {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.curator-list-metric-header span:last-child {\n  color: #002FA7;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.curator-list-progress {\n  height: 4px;\n  background: #f1f5f9;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.curator-list-progress-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n\n/* Детальная информация о группе */\n.curator-details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.curator-details-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.curator-back-btn {\n  background: white;\n  border: none;\n  padding: 0;\n  border-radius: 50%;\n  margin-left: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.curator-back-btn:hover {\n  background: white;\n  transform: scale(1.1);  \n}\n\n.curator-back-btn img {\n  width: 30px;\n  height: 30px;\n  transition: all 0.2s ease;\n}\n\n.curator-details-header h2 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.curator-monitor-radio {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 50%;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.curator-monitor-radio:checked {\n  border-color: #002FA7;\n  background: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.curator-monitor-radio:checked::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 8px;\n  background: white;\n  border-radius: 50%;\n}\n\n.curator-monitor-radio:hover {\n  border-color: #002FA7;\n  transform: scale(1.1);\n}\n\n.curator-monitor-radio:focus {\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.2);\n}\n\n/* Стили для ячейки с радио-кнопкой */\n.curator-student-actions {\n  width: 60px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.curator-student-actions input[type=\"radio\"] {\n  margin: 0 auto;\n  display: block;\n}\n\n\n/* Секция старосты */\n.curator-monitor-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-monitor-section h3 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.curator-monitor-section h3 img {\n  width: 24px;\n  height: 24px;\n}\n\n/* Красивая карточка старосты - минималистичный дизайн */\n.curator-monitor-card {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 24px;\n  background: #ffffff;\n  border-radius: 16px;\n  border: 1px solid #e6edf5;\n  flex-wrap: wrap;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.06);\n  transition: all 0.2s ease;\n}\n\n.curator-monitor-card:hover {\n  border-color: #cbd6e6;\n  box-shadow: 0 6px 16px rgba(0, 47, 167, 0.1);\n}\n\n.curator-monitor-details {\n  flex: 1;\n  min-width: 250px;\n}\n\n.curator-monitor-name-large {\n  font-size: 18px;\n  font-weight: 600;\n  color: #002FA7;\n  margin-bottom: 10px;\n  letter-spacing: -0.2px;\n}\n\n.curator-monitor-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  font-size: 14px;\n  color: #4f5b66;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n/* Левая группа - дата */\n.curator-monitor-meta .meta-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n/* Правая группа - телефон и почта */\n.curator-monitor-meta .meta-right {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-left: auto;\n}\n\n.curator-monitor-meta .meta-right span {\n  color: #3a4b63;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .curator-monitor-card {\n    padding: 16px 20px;\n  }\n  \n  .curator-monitor-name-large {\n    font-size: 18px;\n  }\n  \n  .curator-monitor-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .curator-monitor-meta .meta-right {\n    margin-left: 0;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width: 100%;\n  }\n  \n  .curator-monitor-meta .meta-right span {\n    white-space: normal;\n  }\n}\n\n/* Таблица студентов */\n.curator-students-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  overflow-x: auto;\n}\n\n.curator-students-section h3 {\n  margin: 0 0 20px 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.curator-students-section h3 img {\n  width: 24px;\n  height: 24px;\n}\n\n.curator-students-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.curator-students-table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n}\n\n.curator-students-table th {\n  background: #f8fafc;\n  color: #002c9c;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 12px 8px;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.curator-students-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.curator-student-number {\n  width: 40px;\n  text-align: center;\n  color: #64748b;\n}\n\n.curator-student-name {\n  min-width: 200px;\n}\n\n.curator-student-attendance {\n  width: 70px;\n  text-align: center;\n}\n\n.curator-attendance-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 20px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  min-width: 45px;\n  text-align: center;\n}\n\n.curator-student-average {\n  width: 70px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.curator-student-actions {\n  width: 60px;\n  text-align: center;\n}\n\n.curator-action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.curator-action-btn:hover {\n  background: #f1f5f9;\n}\n\n.curator-action-btn img {\n  width: 16px;\n  height: 16px;\n}\n\n/* Социальный портрет */\n.curator-social-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-social-header {\n  margin-bottom: 20px;\n}\n\n.curator-social-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.curator-social-header h3 img {\n  width: 24px;\n  height: 24px;\n}\n\n.curator-social-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.curator-social-card {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.curator-social-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.curator-social-card-header h4 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.curator-social-count {\n  background: #e2e8f0;\n  color: #002FA7;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.curator-social-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.curator-social-list li {\n  padding: 6px 0;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n  color: #1e293b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.curator-social-list li:last-child {\n  border-bottom: none;\n}\n\n.curator-social-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px dashed #e2e8f0;\n}\n\n/* Модальные окна */\n.curator-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.curator-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 0;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  animation: curator-modal-appear 0.2s ease-out;\n}\n\n@keyframes curator-modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.curator-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 16px 16px 0 0;\n  color: white;\n}\n\n.curator-modal-header-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.curator-modal-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.curator-modal-icon img {\n  width: 22px;\n  height: 22px;\n  filter: brightness(0) invert(1);\n}\n\n.curator-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n}\n\n.curator-modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  opacity: 0.9;\n  font-weight: 400;\n  color: white;\n}\n\n.curator-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: white;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.curator-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.curator-modal-content {\n  padding: 24px;\n}\n\n.curator-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 0 0 16px 16px;\n  flex-wrap: wrap;\n}\n\n/* Формы */\n.curator-form-group {\n  margin-bottom: 20px;\n}\n\n.curator-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n.curator-input,\n.curator-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.curator-input:focus,\n.curator-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.curator-form-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n/* Кнопки в модальных окнах */\n.curator-btn-secondary {\n  padding: 10px 20px;\n  background: white;\n  color: #1e293b;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-btn-secondary:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.curator-confirm-btn {\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-confirm-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n/* Список студентов для смены старосты */\n.curator-students-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.curator-student-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.curator-student-option:hover {\n  border-color: #002FA7;\n  background: white;\n  transform: translateX(4px);\n}\n\n.curator-student-avatar {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.curator-student-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.curator-student-name-option {\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.curator-student-details {\n  font-size: 12px;\n  color: #64748b;\n}\n\n/* Адаптивность */\n@media (max-width: 1200px) {\n  .curator-groups-cards {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  }\n}\n\n@media (max-width: 1024px) {\n  .curator-controls-top-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .curator-view-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-view-btn {\n    flex: 1;\n    justify-content: center;\n  }\n  \n  .curator-controls-bottom-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .curator-sort-controls-enhanced {\n    min-width: 100%;\n  }\n  \n  .curator-sort-group {\n    width: 100%;\n  }\n  \n  .curator-sort-select {\n    flex: 1;\n  }\n  \n  .curator-course-filter-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .curator-list-metrics {\n    min-width: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .curator-cabinet-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .curator-header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .curator-control-panel-enhanced {\n    padding: 16px;\n  }\n  \n  .curator-section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .curator-groups-count {\n    align-self: flex-start;\n  }\n  \n  .curator-group-card {\n    padding: 16px;\n  }\n  \n  .curator-card-stats {\n    flex-wrap: wrap;\n  }\n  \n  .curator-group-list-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .curator-list-number {\n    display: none;\n  }\n  \n  .curator-list-info {\n    width: 100%;\n  }\n  \n  .curator-list-header {\n    justify-content: space-between;\n    width: 100%;\n  }\n  \n  .curator-list-stats {\n    justify-content: space-between;\n  }\n  \n  .curator-view-toggle {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-sort-group {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 12px;\n  }\n  \n  .curator-sort-select {\n    width: 100%;\n    max-width: none;\n  }\n  \n  .curator-sort-order-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-sort-buttons {\n    width: 100%;\n  }\n  \n  .curator-course-filter-right {\n    flex-wrap: wrap;\n  }\n  \n  .curator-course-select {\n    flex: 1;\n  }\n  \n  .curator-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .curator-monitor-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .curator-monitor-meta {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .curator-monitor-change-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .curator-social-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .curator-modal-actions {\n    flex-direction: column;\n  }\n  \n  .curator-btn-secondary,\n  .curator-confirm-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .curator-groups-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .curator-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .curator-card-course {\n    align-self: flex-start;\n  }\n  \n  .curator-view-btn span {\n    display: none;\n  }\n  \n  .curator-view-btn {\n    padding: 10px;\n  }\n  \n  .curator-sort-order-btn span {\n    display: none;\n  }\n  \n  .curator-sort-order-btn {\n    padding: 10px;\n    justify-content: center;\n  }\n  \n  .curator-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .curator-list-stats {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .curator-card-stats {\n    flex-direction: column;\n  }\n}\n\n/* Обновленные стили для кнопки назад */\n.curator-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.curator-back-btn:hover {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.curator-back-btn:active {\n  transform: translateY(0);\n}\n\n.curator-back-btn img {\n  width: 18px;\n  height: 18px;\n}\n\n/* Мультистрочное отображение старост */\n.curator-headman-value {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.curator-monitor-name-line {\n  font-size: 14px;\n  color: #1e293b;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.curator-detail-value-multiline {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.curator-detail-value-multiline div {\n  font-size: 13px;\n  color: #002FA7;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
